module.exports = __webpack_public_path__ + "static/00014.32ca544f.jpg";